import { useNavigate, useSearchParams } from "@solidjs/router";
import { createEffect } from "solid-js";
import { ScreenLoader } from "../components/Spinner";
import { nextStepFor, session } from "../state/session";

/**
 * Landing point after sign-in from "Scanner un vélo" / "Scanner et démarrer": resolves the next step
 * (activation, payment, then scan) once the session is known. Waiting avoids treating a still-loading
 * session as signed out, which would bounce back to sign-in.
 */
export function Start() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  createEffect(() => {
    if (session.me.loading) return;
    const vehicle = typeof params.vehicle === "string" ? params.vehicle : undefined;
    navigate(nextStepFor(session.me() ?? null, vehicle), { replace: true });
  });
  return (
    <main class="screen bg-surface" aria-busy="true">
      <ScreenLoader />
    </main>
  );
}
